import { render } from "./calendario-vacinacao.vue?vue&type=template&id=537234d4&scoped=true"
import script from "./calendario-vacinacao.vue?vue&type=script&lang=js"
export * from "./calendario-vacinacao.vue?vue&type=script&lang=js"

import "./calendario-vacinacao.vue?vue&type=style&index=0&id=537234d4&scoped=true&lang=css"
import "./calendario-vacinacao.vue?vue&type=style&index=1&id=537234d4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537234d4"]])

export default __exports__